import { createContext, type ReactNode } from 'react';

import { type HeldBackFields, HeldBackFieldsContext } from './heldBackFields';

/**
 * Whether the viewer is a client admin. Such a viewer reads advanced settings without
 * changing them, and is told whom to ask about stored data it cannot act on. Outside a
 * data source card (the admin-only account editor) it is false.
 */
export const ClientAdminViewContext = createContext(false);

export interface FieldContextsProps {
    heldBack: HeldBackFields | null;
    clientAdmin: boolean;
    children: ReactNode;
}

/** What a form tells every ProviderSchemaField inside it. */
export function FieldContexts({ heldBack, clientAdmin, children }: FieldContextsProps) {
    return (
        <HeldBackFieldsContext.Provider value={heldBack}>
            <ClientAdminViewContext.Provider value={clientAdmin}>
                {children}
            </ClientAdminViewContext.Provider>
        </HeldBackFieldsContext.Provider>
    );
}
